import { render, staticRenderFns } from "./shopAlarm.vue?vue&type=template&id=bfcfc966&scoped=true"
import script from "./shopAlarm.vue?vue&type=script&lang=js"
export * from "./shopAlarm.vue?vue&type=script&lang=js"
import style0 from "./shopAlarm.vue?vue&type=style&index=0&id=bfcfc966&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcfc966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfcfc966')) {
      api.createRecord('bfcfc966', component.options)
    } else {
      api.reload('bfcfc966', component.options)
    }
    module.hot.accept("./shopAlarm.vue?vue&type=template&id=bfcfc966&scoped=true", function () {
      api.rerender('bfcfc966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/run/shopAlarm.vue"
export default component.exports